import { Image } from "@chakra-ui/react";
import { useMemo } from "react";
import useScreen from "../../../hooks/useScreen";
import { Channel } from "../../../interfaces/tracking";
import { Analytics, EventNames } from "../../../utils/tracking";

interface ShareLookButtonProps {
  imageUrl: string;
  gnomeId: string;
}

export const ShareLookButton = (props: ShareLookButtonProps) => {
  const imageUrl = useMemo(() => props.imageUrl, [props.imageUrl]);
  const gnomeId = useMemo(() => props.gnomeId, [props.gnomeId]);
  const { isMobile } = useScreen();

  const createImage = async () => {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const newFile = new File([blob], "share-look-image.png", {
      type: "image/png",
    });

    return newFile;
  };

  const platform: string =
    new URLSearchParams(location.search).get("platform") ?? "";

  const handleShare = async () => {
    Analytics.event(Channel.GA, EventNames.SHARE_CLICKED, {
      device: platform.includes("g-mob")
        ? "app"
        : isMobile
        ? "mobile"
        : "desktop",
      style_id: gnomeId,
    });

    try {
      const file = await createImage();
      await navigator.share({ files: [file] });
    } catch (error) {}
  };

  return (
    <>
      {typeof navigator.share === "function" ? (
        <Image
          cursor="pointer"
          src={process.env.PUBLIC_URL + "/assets/images/Share.svg"}
          onClick={handleShare}
          height={isMobile ? "42px" : "52px"}
          width={isMobile ? "42px" : "52px"}
        />
      ) : null}
    </>
  );
};
